export default class BaseEnumType {
    constructor(code, name) {
        this.code = code;
        this.name = name;
    }

    equals(other) {
        return other && other.code && this.code === other.code;
    }
}
